// ============================================
// スクロールアニメーション（IntersectionObserver）
// ============================================

/**
 * スクロールアニメーションを初期化
 *
 * data-inview 属性で種類を指定:
 *   "fadein"   — フェードイン（opacity: 0 → 1）
 *   "slideup"  — スライドアップ（opacity: 0 + translateY → 通常位置）
 *   "addclass" — is-show クラスを付与
 */
export function initInview() {
	const targets = document.querySelectorAll('[data-inview]');
	if (targets.length === 0) return;

	const observer = new IntersectionObserver(handleIntersect, {
		root: null,
		rootMargin: '0px 0px -25% 0px',
		threshold: 0,
	});

	targets.forEach((target) => {
		observer.observe(target);
	});

	/**
	 * 交差時のコールバック
	 * @param {IntersectionObserverEntry[]} entries - 監視対象のエントリー
	 */
	function handleIntersect(entries) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;

			const el = entry.target;
			const type = el.getAttribute('data-inview');

			switch (type) {
				case 'fadein':
					el.classList.add('is-inview');
					break;
				case 'slideup':
					el.classList.add('is-inview');
					break;
				case 'addclass':
					el.classList.add('is-show');
					break;
				default:
					break;
			}

			/* 一度発火したら監視を解除 */
			observer.unobserve(el);
		});
	}
}
